<script setup>
import { onMounted, ref, watch, onBeforeUnmount, nextTick } from 'vue';
import { getChartThemeColors } from '../helpers/reportChartTheme';

const props = defineProps({
  labels: Array,
  values: Array,
  colors: Array,
  title: String,
});

const chartRef = ref(null);
let chartInstance = null;

const destroyChart = () => {
  if (chartInstance) {
    chartInstance.destroy();
    chartInstance = null;
  }
};

const renderChart = async () => {
  await nextTick();
  destroyChart();
  if (!chartRef.value) return;
  const ctx = chartRef.value.getContext && chartRef.value.getContext('2d');
  if (!ctx) return;
  const Chart = (await import('chart.js/auto')).default;
  const theme = getChartThemeColors();
  chartInstance = new Chart(ctx, {
    type: 'pie',
    data: {
      labels: props.labels,
      datasets: [
        {
          data: props.values,
          backgroundColor: props.colors,
        },
      ],
    },
    options: {
      plugins: {
        legend: {
        display: true,
        position: 'bottom',
        labels: { color: theme.legend },
      },
        tooltip: {
          callbacks: {
            label: context => `${context.label}: ${context.parsed} (${((context.parsed / props.values.reduce((a,b)=>a+b,0)) * 100).toFixed(1)}%)`,
          },
        },
      },
      responsive: true,
      maintainAspectRatio: false,
    },
  });
};

onMounted(renderChart);
watch(() => [props.labels, props.values, props.colors], renderChart, { deep: true });
onBeforeUnmount(destroyChart);
</script>

<template>
  <div>
    <h3 class="font-semibold text-base mb-2">{{ title }}</h3>
    <div style="height: 180px; width: 100%">
      <canvas ref="chartRef"></canvas>
    </div>
  </div>
</template> 